import { ContextMetricEnum, ContextMetricUnitEnum } from '@shared/api/types';
import { SelectOption } from '@shared/components/form/select-form-field';

interface MetricOption extends SelectOption {
  metricLabel?: string;
}

export const NO_METRIC_OPTION = 'no_metric';

export const metricOptions: MetricOption[] = [
  {
    label: 'I do not want to use a metric',
    value: NO_METRIC_OPTION,
  },
  {
    label: 'Number of people served',
    metricLabel: 'Total people served',
    value: ContextMetricEnum.people_served,
  },
  {
    label: 'Money spent',
    metricLabel: 'Total spent',
    value: ContextMetricEnum.money_spent,
  },
  {
    label: 'Money earned',
    metricLabel: 'Total earned',
    value: ContextMetricEnum.money_earned,
  },
];

export const metricUnits: SelectOption[] = [
  {
    label: '£',
    value: ContextMetricUnitEnum.GBP,
  },
  {
    label: '€',
    value: ContextMetricUnitEnum.EUR,
  },
  {
    label: '$',
    value: ContextMetricUnitEnum.USD,
  },
];
